(() => {
  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;',
    })[character]);

  const formatPrice = (price) =>
    new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(Number(price || 0));

  const isHiddenClone = (product) =>
    ['-billiger-de', '-guenstiger-de', '-heureka-sk'].some((suffix) => product.handle?.includes(suffix));

  document.querySelectorAll('[data-rdr-predictive-search]').forEach((form) => {
    if (form.dataset.rdrPredictiveReady) return;
    form.dataset.rdrPredictiveReady = 'true';

    const input = form.querySelector('input[name="q"]');
    const results = form.querySelector('.rdr-predictive-search__results');
    const endpoint = form.dataset.searchEndpoint;
    let controller;
    let timer;

    if (!input || !results || !endpoint) return;

    const closeResults = () => {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };

    const renderResults = (products, term) => {
      const availableProducts = products.filter((product) => !isHiddenClone(product));

      if (!availableProducts.length) {
        results.innerHTML = `<p class="rdr-predictive-search__empty">${escapeHtml(form.dataset.searchEmpty)}</p>`;
      } else {
        results.innerHTML = `
          <p class="rdr-predictive-search__label">${escapeHtml(form.dataset.searchProducts)}</p>
          <div class="rdr-predictive-search__list">
            ${availableProducts.map((product) => {
              const image = product.featured_image?.url || product.image || '';
              const compareAtPrice = Number(product.compare_at_price || product.compare_at_price_min || 0);
              const price = Number(product.price || product.price_min || 0);
              const imageMarkup = image
                ? `<img src="${escapeHtml(image)}" alt="" width="48" height="48" loading="lazy">`
                : '<span class="rdr-predictive-search__image-placeholder"></span>';
              const compareMarkup = compareAtPrice > price ? `<s>${formatPrice(compareAtPrice)}</s>` : '';

              return `<a class="rdr-predictive-search__item" href="${escapeHtml(product.url)}" role="option">
                <span class="rdr-predictive-search__image">${imageMarkup}</span>
                <span class="rdr-predictive-search__content">
                  <strong>${escapeHtml(product.title)}</strong>
                  <span class="rdr-predictive-search__price">${formatPrice(price)}${compareMarkup}</span>
                </span>
              </a>`;
            }).join('')}
          </div>
          <a class="rdr-predictive-search__all" href="${escapeHtml(form.action)}?q=${encodeURIComponent(term)}">${escapeHtml(form.dataset.searchAll)}</a>
        `;
      }

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const search = async () => {
      const term = input.value.trim();
      if (term.length < 2) {
        closeResults();
        return;
      }

      controller?.abort();
      controller = new AbortController();

      try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        if (!controller.signal.aborted) renderResults(data.resources?.results?.products || [], term);
      } catch (error) {
        if (error.name !== 'AbortError') closeResults();
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 180);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeResults();
    });
    input.addEventListener('focusout', () => window.setTimeout(closeResults, 160));
  });
})();
